// import './vendor';
import year from './components/year';
import board from './components/board';
import lang from './components/lang';

document.addEventListener('DOMContentLoaded', () => {
	year.init();
	lang.init();
	board.init();
});
